// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolData } from './protocol-data';
import {
    ProtocolDataFromJSON,
    ProtocolDataFromJSONTyped,
    ProtocolDataToJSON,
    ProtocolDataToJSONTyped,
} from './protocol-data';

/**
 * 
 * @export
 * @interface UpdateProtocolRequest
 */
export interface UpdateProtocolRequest {
    /**
     * 
     * @type {ProtocolData}
     * @memberof UpdateProtocolRequest
     */
    data: ProtocolData;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProtocolRequest
     */
    submit?: boolean;
}

/**
 * Check if a given object implements the UpdateProtocolRequest interface.
 */
export function instanceOfUpdateProtocolRequest(value: object): value is UpdateProtocolRequest {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateProtocolRequestFromJSON(json: any): UpdateProtocolRequest {
    return UpdateProtocolRequestFromJSONTyped(json, false);
}

export function UpdateProtocolRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProtocolRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ProtocolDataFromJSON(json['data']),
        'submit': json['submit'] == null ? undefined : json['submit'],
    };
}

export function UpdateProtocolRequestToJSON(json: any): UpdateProtocolRequest {
    return UpdateProtocolRequestToJSONTyped(json, false);
}

export function UpdateProtocolRequestToJSONTyped(value?: UpdateProtocolRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ProtocolDataToJSON(value['data']),
        'submit': value['submit'],
    };
}
